var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConvert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.05,
    height: 30,
    viewBox: "0 0 30.05 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.55 5.6a1.569 1.569 0 0 1 0 2.2l-5.9 5.6-.6-.8 5.6-5.4H1.05v5.6h-1V6.2h28.6L23.05.8l.7-.8zM6.35 30l.7-.8-5.6-5.4h28.6v-6.7h-1v5.6H1.45l5.6-5.3-.7-.8-5.9 5.6a1.569 1.569 0 0 0 0 2.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert);
export default __webpack_public_path__ + "static/media/convert.c2bcd8b0092045619a646c46ed15e833.svg";
export { ForwardRef as ReactComponent };